import { infer as Infer, z } from 'zod';

import { userCreateSchema } from './userCreate.schema';

export const userMassImportSchema = userCreateSchema.omit({ lvl: true, password: true }).extend({
  phone: z
    .string()
    .nullable()
    .optional()
    .transform((v) => v ?? null),
  birthdate: z
    .string()
    .nullable()
    .optional()
    .transform((v) => v ?? null),
});

export type UserMassImportSchema = Infer<typeof userMassImportSchema>;
